import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import '../styles/Navbar.css';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav__header">
        <div className="nav__logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img 
              src="/assets/phupatpharma.logo.png" 
              alt="Dr. BhuPat Pharma Logo" 
              className="logo-img" 
            />
            <div className="text-3xl font-bold">
              <span className="text-black">Dr.</span>
              <span className="text-green-500">Bhu</span>
              <span className="text-blue-500">Pat</span>
              <span className="text-black"> Pharma Pvt Ltd.</span>
            </div>
          </Link>
        </div>

        <button
          className="nav__menu__btn"
          id="menu-btn"
          aria-expanded={mobileMenuOpen}
          aria-label="Toggle menu"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <RiCloseLine /> : <RiMenu3Line />}
        </button>

        <ul className={`nav__links ${mobileMenuOpen ? 'active' : ''}`} id="nav-links">
          <li>
            <Link to="/" onClick={closeMobileMenu}>HOME</Link>
          </li>
          
          <li className="nav-item">
            <span className="nav-link">ABOUT US</span>
            <ul className="submenu">
              <li><Link to="/ourvision" onClick={closeMobileMenu}>Our Vision</Link></li>
              <li><Link to="/companyoverview" onClick={closeMobileMenu}>Company Overview</Link></li>
              <li><Link to="/ourteam" onClick={closeMobileMenu}>Our Teams</Link></li>
              <li><Link to="/ethicsvalues" onClick={closeMobileMenu}>Ethics and Values</Link></li>
              <li><Link to="/voyage" onClick={closeMobileMenu}>Voyage</Link></li>
            </ul>
          </li>
          
          <li className="nav-item">
            <span className="nav-link">OUR PRODUCTS</span>
            <ul className="submenu">
              <li><Link to="/products" onClick={closeMobileMenu}>Products</Link></li>
            </ul>
          </li>
          
          <li className="nav-item">
            <span className="nav-link">CAREERS</span>
            <ul className="submenu">
              <li><Link to="/life-at" onClick={closeMobileMenu}>Work Culture</Link></li>
              {/* <li><Link to="/work-culture" onClick={closeMobileMenu}>Work Culture</Link></li> */}
              <li><Link to="/career" onClick={closeMobileMenu}>Career</Link></li>
            </ul>
          </li>
          
          <li>
            <Link to="/contact" onClick={closeMobileMenu}>CONTACT US</Link>
          </li>
          
          <li>
            <Link to="/privacy-policy" onClick={closeMobileMenu}>PRIVACY POLICY</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;